import React from "react";
import { Typography } from "@mui/material";


export const Header = () => {
    return <>
        <Typography
            sx={{
                margin: "10px"
            }}
            variant="h6"
        >
            Jh123x Search
        </Typography>
    </>
}